export default {
  radioGroupLabel: {
    id: 'payment_network_radio_label',
    defaultMessage: 'Preferred payment network',
  },
}
